"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M3 17h18v2H3zm16-5v1H5v-1zm2-2H3v5h18zM3 6h18v2H3z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M5 12h14v1H5z",
  opacity: ".3"
}, "1")], 'CalendarViewDayTwoTone');